import { loader } from 'graphql.macro'

export default function reportsDriverComparisonQuery ({ dataLoaders, queryKey }) {
  const [,
    startDate,
    endDate,
    years,
    resourceTypes,
    ticketTypes,
    status
  ] = queryKey

  const reportsDriverComparisonSchema = loader('./reportsDriverComparison.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(reportsDriverComparisonSchema, { startDate, endDate, years, resourceTypes, ticketTypes, status })
}
